export const getCourierName = (phone, couriers) => {
  const courier = couriers?.find((c) => c.phone === phone);
  if (courier) {
    return { name: courier.name, phone: courier.phone };
  }

  return { name: '-------', phone };
};
